import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'

import Contest from '../../../../services/Contest'

import './styles.css'

function EvaluateSection() {
  const [contest, setContest] = useState([])

  const { id } = useParams()
  const history = useHistory()

  const evaluate = (value) => {
    Contest.evaluate(id, value)
      .then(() => {
        history.push('../contest')
      })
      .catch(err => {
        alert('Erro ao processar requisição')
        console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
      })
  }

  useEffect(() => {
    Contest.search(id)
      .then(res => {
        setContest(res)
      })
      .catch(err => {
        alert('Erro ao processar requisição')
        console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
      })
  }, [id])

  return (
    <div id="evaluate-section">
      <h3>{contest.title}</h3>
      <span>Autor: {contest.authorName}</span>
        <span>Email: <a href={"mailto:"+contest.authorEmail}>{contest.authorEmail}</a></span>
      <span>{contest.category}</span>
      <iframe
        title={contest.title}
        src={contest.document}
        className="frame-evaluate"
      />
      <div className='choice-content-evaluate'>
        <button
          className='reproved-button-evaluate'
          onClick={() => evaluate(false)}>
          Reprovar
        </button>
        <button
          className='approved-button-evaluate'
          onClick={() => evaluate(true)}>
          Aprovar
        </button>
      </div>
    </div>
  )
}

export default EvaluateSection
